import { LIST_ITEMS_PER_PAGE_LIST } from '../../constants/constants';
import { TNeedleManagementActions } from './needle-management.actions';
import { TNeedleManagementInfoActionType, TNeedleManagementState } from './needle-management.models';

export const intialState: TNeedleManagementState = {
  needleListingInfo: null,
  needleListDropdownInfo: null,
  needleRequests: null,
  localStoreNeedleRequests: null,
  needleListingPagination: { pageNo: 1, pageSize: LIST_ITEMS_PER_PAGE_LIST[0] },
  needleRequestPagination: { pageNo: 1, pageSize: LIST_ITEMS_PER_PAGE_LIST[0] },
  localNeedleRequestPagination: { pageNo: 1, pageSize: LIST_ITEMS_PER_PAGE_LIST[0] },
};

export function needleManagementReducer(state = intialState, action: TNeedleManagementActions): TNeedleManagementState {
  switch (action.type) {
    case TNeedleManagementInfoActionType.SetNeedleListPagination:
      return {
        ...state,
        needleListingPagination: action.pagination,
      };
    case TNeedleManagementInfoActionType.GetNeedleListSuccess:
      return {
        ...state,
        needleListingInfo: {
          res: action.needleListRes,
          fetchReason: action.fetchReason,
        },
      };
    case TNeedleManagementInfoActionType.GetNeedleListDropdownSuccess:
      return {
        ...state,
        needleListDropdownInfo: action.res,
      };
    case TNeedleManagementInfoActionType.SetNeedleRequestPagination:
      return {
        ...state,
        needleRequestPagination: action.pagination,
      };
    case TNeedleManagementInfoActionType.GetNeedleRequestListSuccess:
      return {
        ...state,
        needleRequests: {
          res: action.res,
          fetchReason: action.fetchReason,
        },
      };
    case TNeedleManagementInfoActionType.SetLocalNeedleRequestPagination:
      return {
        ...state,
        localNeedleRequestPagination: action.pagination,
      };
    case TNeedleManagementInfoActionType.GetLocalStoreRequestsSuccess:
      return {
        ...state,
        localStoreNeedleRequests: {
          res: action.res,
          fetchReason: action.fetchReason,
        },
      };
    default:
      return state;
  }
}
